import { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import { useNavigate } from "react-router-dom";
import { useFileUpload } from "../../lib/useFileUpload";
import UploadProgressBar from "../../shared-ui-components/UploadProgressBar";
import PopUp from "../../shared-ui-components/PopUp";
import SubscribeForm from "../../shared-ui-components/SubscribeForm";
import SignInModal from "../../components/SignInModal";

interface FileUploadButtonProps {
  disabled?: boolean;
}

const FileUploadButton: React.FC<FileUploadButtonProps> = ({ disabled }) => {
  const navigate = useNavigate();
  const [isSignInModalVisible, setIsSignInModalVisible] = useState(false);

  const {
    uploadProps,
    uploadKey,
    showProgress,
    isAnalysing,
    progressPercentage,
    showSubscribeModal,
    setShowSubscribeModal,
  } = useFileUpload((analysisId) => navigate(`/analysis/${analysisId}`));

  return (
    <>
      <Upload key={uploadKey} {...uploadProps}>
        <Button
          type="primary"
          icon={<SearchOutlined />}
          className={`upload-button ${disabled ? "inactive" : ""}`}
        >
          Upload File
        </Button>
      </Upload>

      {(showProgress || isAnalysing) && (
        <div className="upload-loading-overlay">
          <div className="upload-loading-content">
            <h2>{isAnalysing ? "Analysing" : "Uploading"}</h2>
            {showProgress && (
              <UploadProgressBar
                percentage={progressPercentage}
                showPercentage={true}
                height={14}
              />
            )}
            {isAnalysing && !showProgress && (
              <div className="donut">
                <svg version="1.1" width="120px" height="120px">
                  <g transform="translate(60, 60)">
                    <circle r="50" className="circle-back" />
                    <circle r="50" className="circle-front" />
                  </g>
                </svg>
              </div>
            )}
          </div>
        </div>
      )}

      <PopUp
        openModal={showSubscribeModal}
        setOpenModal={setShowSubscribeModal}
        fullWidth={0}
      >
        <SubscribeForm
          setOpenModal={setShowSubscribeModal}
          onSignUp={() => setIsSignInModalVisible(true)}
        />
      </PopUp>
      <SignInModal
        isVisible={isSignInModalVisible}
        onClose={() => setIsSignInModalVisible(false)}
        onSignInSuccess={() => setIsSignInModalVisible(false)}
      />
    </>
  );
};

export default FileUploadButton;
